import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface TodayVisitsFilterProps {
  isActive: boolean;
  onToggle: (active: boolean) => void;
}

export const TodayVisitsFilter = ({
  isActive,
  onToggle,
}: TodayVisitsFilterProps) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={() => onToggle(!isActive)}
      variant={isActive ? "default" : "outline"}
      size="sm"
    >
      {t("contractorVisits.todayFilter.label")}
    </Button>
  );
};
